import { render, staticRenderFns } from "./WhatAreDrops.vue?vue&type=template&id=161d7a9f&scoped=true&"
import script from "./WhatAreDrops.vue?vue&type=script&lang=js&"
export * from "./WhatAreDrops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d7a9f",
  null
  
)

export default component.exports